import React, { useEffect, useState } from "react";
import {
  Settings,
  HelpCircle,
  UserCog,
  Shield,
  Truck,
  SearchCheck,
  Bot,
  FileText,
  Users,
  HeartHandshake,
  BookAIcon,
  ListChecks,
  BookCheckIcon,
} from "lucide-react";
import { getRoleId } from "Common/Components/getRoleId";

const TOKEN_KEY = "app_havir";

// نقش‌های مجاز برای هر بخش
const ALL_ROLES = [0, 1, 2, 3, 4, 5, 6];           // تنظیمات و پشتیبانی (بدون ۷)
const ORDERS_ROLES = [0, 1, 3, 5, 6, 7];           // حواله‌های نانوا (شامل شرکت حمل)
const USERS_ROLES = [0, 1, 5, 6];                  // مدیریت کاربران، سهمیه، گزارش تخلفات، گزارش‌ها (بدون ۷)
const SHIPPING_ROLES = [7];                        // نقش شرکت حمل (برای منوهای اختصاصی)
const DRIVER_ROLES = [4];
const INSPECTOR_ROLES = [0, 1, 2, 5, 6];
const AI_OBSERVER_ROLES = [0, 1, 3, 5, 6];
const ADMINROLE = [0];
// اطلاعات خبازی ها: admin، superadmin، بازرس شهرستان، مدیر شهرستان و مدیر استان
const BAKERY_INFO_ROLES = [0, 1, 2, 5, 6];

const MenuData = () => {
  const [userRole, setUserRole] = useState<number | null>(null);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUserRole(null);
      return;
    }
    const role = getRoleId(token);
    setUserRole(role);
  }, []);

  const hasAccess = (roles: number[]) => userRole !== null && roles.includes(userRole);

  const menuData: any = [
    // ---------- حواله های نانوا (برای نقش‌های ORDERS_ROLES شامل ۷) ----------
    ...(hasAccess(ORDERS_ROLES)
      ? [
        {
          id: "all-orders",
          label: "حواله های نانوا",
          link: "/ManageOrders",
          icon: <FileText size={18} />,
        },
      ]
      : []),

    // ---------- وظایف راننده (برای نقش‌های USERS_ROLES یا SHIPPING_ROLES) ----------
    ...((hasAccess(USERS_ROLES) || hasAccess(SHIPPING_ROLES))
      ? [
        {
          id: "driver-tasks",
          label: "وظایف راننده",
          link: "/DriverTasks",
          icon: <Truck size={20} />,
        },
      ]
      : []),

    // ---------- پنل راننده (فقط نقش ۴) ----------
    ...(hasAccess(DRIVER_ROLES)
      ? [
        {
          id: "driver-tasks",
          label: "وظایف راننده",
          link: "/DriverTasks",
          icon: <Truck size={20} />,
        },
      ]
      : []),

    // ---------- وظایف بازرس شهرستان ----------
    ...(hasAccess(INSPECTOR_ROLES)
      ? [
        {
          id: "inspector-tasks",
          label: "وظایف بازرس شهرستان",
          link: "/InspectorTasks",
          icon: <SearchCheck size={20} />,
        },
      ]
      : []),

    // ---------- ناظر هوش مصنوعی ----------
    ...(hasAccess(AI_OBSERVER_ROLES)
      ? [
        {
          id: "ai-tasks",
          label: "وظایف ناظر هوش مصنوعی",
          link: "/AITasks",
          icon: <Bot size={18} />,
        },
      ]
      : []),

    // ---------- سهمیه خبازی ها (فقط USERS_ROLES، بدون ۷) ----------
    ...(hasAccess(USERS_ROLES)
      ? [
        {
          id: "masme",
          label: "سهمیه خبازی ها",
          link: "/BakerQuota",
          icon: <HeartHandshake size={18} />,
        },
      ]
      : []),

    // ---------- گزارش تخلفات (فقط USERS_ROLES، بدون ۷) ----------
    ...(hasAccess(USERS_ROLES)
      ? [
        {
          id: "ViolationsReport",
          label: "گزارش تخلفات",
          link: "/ViolationsReport",
          icon: <BookAIcon size={18} />,
        },
      ]
      : []),

    // ---------- مدیریت کاربران (فقط USERS_ROLES، بدون ۷) ----------
    ...(hasAccess(USERS_ROLES)
      ? [
        {
          id: "manage-users",
          label: "مدیریت کاربران",
          link: "/manageUser",
          icon: <Users size={18} />,
        },
      ]
      : []),

    // ---------- گزارش‌ها (فقط USERS_ROLES، بدون ۷) ----------
    ...(hasAccess(USERS_ROLES)
      ? [
        {
          id: "reports",
          label: "گزارش ها",
          link: "/reports",
          icon: <ListChecks size={18} />,
        },
      ]
      : []),
    ...(hasAccess(USERS_ROLES)
      ? [
        {
          id: "ReportsDecadePage",
          label: "گزارش دهه ",
          link: "/ReportsDecadePage",
          icon: <BookCheckIcon size={18} />,
        },
      ]
      : []),


    // ---------- اطلاعات خبازی ها ----------
    ...(hasAccess(BAKERY_INFO_ROLES)
      ? [
        {
          id: "BakeryInformation",
          label: "اطلاعات خبازی ها",
          link: "/BakeryInformation",
          icon: <BookCheckIcon size={18} />,
        },
      ]
      : []),

    // ---------- تنظیمات (فقط ALL_ROLES، بدون ۷) ----------
    ...(hasAccess(ALL_ROLES)
      ? [

        {
          id: "settings",
          label: "تنظیمات",
          link: "/#",
          icon: <Settings size={20} />,
          subItems: [
            ...(hasAccess(ADMINROLE)
              ? [
                {
                  id: "AdminSettings",
                  label: "  تنظیمات  تخلیه و بازرسی",
                  link: "/AdminSettings",
                  icon: <Settings size={18} />,
                },
              ]
              : []),

            {
              id: "user-profile",
              label: "پروفایل کاربری",
              link: "/user-profile",
              icon: <UserCog size={18} />,
            },
            {
              id: "change-password",
              label: "تغییر رمز عبور",
              link: "/user-profile",
              icon: <Shield size={18} />,
            },
            {
              id: "logout",
              label: "خروج",
              link: "/logout",
              icon: <HelpCircle size={18} />,
            },
          ],
        },
      ]
      : []),

    // ---------- پشتیبانی (فقط ALL_ROLES، بدون ۷) ----------
    // ...(hasAccess(ALL_ROLES)
    //   ? [
    //     {
    //       id: "support",
    //       label: "پشتیبانی",
    //       link: "/#",
    //       icon: <HelpCircle size={20} />,
    //       subItems: [
    //         {
    //           id: "faq",
    //           label: "راهنما",
    //           link: "",
    //           icon: <HelpCircle size={18} />,
    //         },
    //       ],
    //     },
    //   ]
    //   : []),
  ];

  return menuData;
};

export default MenuData;
// import React, { useEffect, useState } from "react";
// import {
//   Settings,
//   HelpCircle,
//   UserCog,
//   Shield,
//   Truck,
//   SearchCheck,
//   Bot,
//   FileText,
//   Users,
//   HeartHandshake,
//   BookAIcon,
//   DatabaseBackup,
//   ListChecks,
// } from "lucide-react";
// import { getRoleId } from "Common/Components/getRoleId";

// const TOKEN_KEY = "app_havir";

// const ALL_ROLES = [0, 1, 2, 3, 4, 5, 6  7];
// const ORDERS_ROLES = [0, 1, 3, 5, 6];
// const USERS_ROLES = [0, 1, 5, 6];               // برای مدیریت کاربران و وظایف راننده
// const DRIVER_ROLES = [4];
// const INSPECTOR_ROLES = [0, 1, 2, 5, 6];
// const AI_OBSERVER_ROLES = [0, 1, 3, 5, 6];

// const MenuData = () => {
//   const [userRole, setUserRole] = useState<number | null>(null);

//   useEffect(() => {
//     const token = localStorage.getItem(TOKEN_KEY);
//     if (!token) {
//       setUserRole(null);
//       return;
//     }
//     const role = getRoleId(token);
//     setUserRole(role);
//   }, []);

//   const hasAccess = (roles: number[]) => userRole !== null && roles.includes(userRole);
//   const menuData: any = [
//     // ---------- حواله های نانوا ----------
//     ...(hasAccess(ORDERS_ROLES)
//       ? [
//         {
//           id: "all-orders",
//           label: "حواله های نانوا",
//           link: "/ManageOrders",
//           icon: <FileText size={18} />,
//         },
//       ]
//       : []),

//     // ---------- وظایف راننده (برای نقش‌های USERS_ROLES) ----------
//     ...(hasAccess(USERS_ROLES)
//       ? [
//         {
//           id: "driver-tasks",
//           label: "وظایف راننده",
//           link: "/DriverTasks",
//           icon: <Truck size={20} />,
//         },
//       ]
//       : []),

//     // ---------- پنل راننده (فقط نقش ۴) ----------
//     ...(hasAccess(DRIVER_ROLES)
//       ? [
//         {
//           id: "driver-panel",
//           label: "پنل راننده",
//           link: "/#",
//           icon: <Truck size={20} />,
//           subItems: [
//             {
//               id: "my-tasks",
//               label: "ماموریت‌های من",
//               link: "/DriverTasks",
//               icon: <Truck size={18} />,
//             },
//             {
//               id: "my-profile",
//               label: "پروفایل من",
//               link: "/user-profile",
//               icon: <UserCog size={18} />,
//             },
//           ],
//         },
//       ]
//       : []),

//     // ---------- وظایف بازرس شهرستان ----------
//     ...(hasAccess(INSPECTOR_ROLES)
//       ? [
//         {
//           id: "inspector-tasks",
//           label: "وظایف بازرس شهرستان",
//           link: "/InspectorTasks",
//           icon: <SearchCheck size={20} />,
//         },
//       ]
//       : []),

//     // ---------- ناظر هوش مصنوعی ----------
//     ...(hasAccess(AI_OBSERVER_ROLES)
//       ? [
//         {
//           id: "ai-tasks",
//           label: "وظایف ناظر هوش مصنوعی",
//           link: "/AITasks",
//           icon: <Bot size={18} />,
//         },
//       ]
//       : []),

//     // ---------- سهمیه خبازی ها ----------
//     ...(hasAccess(USERS_ROLES)
//       ? [
//         {
//           id: "masme",
//           label: "سهمیه خبازی ها",
//           link: "/BakerQuota",
//           icon: <HeartHandshake size={18} />,
//         },
//       ]
//       : []),

//     // ---------- گزارش تخلفات ----------
//     ...(hasAccess(USERS_ROLES)
//       ? [
//         {
//           id: "ViolationsReport",
//           label: "گزارش تخلفات",
//           link: "/ViolationsReport",
//           icon: <BookAIcon size={18} />,
//         },
//       ]
//       : []),

//     // ---------- مدیریت کاربران (دقیقاً بین گزارش تخلفات و تنظیمات) ----------
//     ...(hasAccess(USERS_ROLES)
//       ? [
//         {
//           id: "manage-users",
//           label: "مدیریت کاربران",
//           link: "/manageUser",
//           icon: <Users size={18} />,
//         },
//       ]
//       : []),
//     ...(hasAccess(USERS_ROLES)
//       ? [
//         {
//           id: "manage-users",
//           label: "گزارش ها",
//           link: "/reports",
//           icon: <ListChecks size={18} />,
//         },
//       ]
//       : []),

//     // ---------- تنظیمات ----------
//     ...(hasAccess(ALL_ROLES)
//       ? [
//         {
//           id: "settings",
//           label: "تنظیمات",
//           link: "/#",
//           icon: <Settings size={20} />,
//           subItems: [
//             {
//               id: "user-profile",
//               label: "پروفایل کاربری",
//               link: "/user-profile",
//               icon: <UserCog size={18} />,
//             },
//             {
//               id: "change-password",
//               label: "تغییر رمز عبور",
//               link: "/user-profile",
//               icon: <Shield size={18} />,
//             },
//             {
//               id: "logout",
//               label: "خروج",
//               link: "/logout",
//               icon: <HelpCircle size={18} />,
//             },
//           ],
//         },
//       ]
//       : []),

//     // ---------- پشتیبانی ----------
//     ...(hasAccess(ALL_ROLES)
//       ? [
//         {
//           id: "support",
//           label: "پشتیبانی",
//           link: "/#",
//           icon: <HelpCircle size={20} />,
//           subItems: [
//             {
//               id: "faq",
//               label: "راهنما",
//               link: "",
//               icon: <HelpCircle size={18} />,
//             },
//           ],
//         },
//       ]
//       : []),
//   ];

//   return menuData;
// };

// export default MenuData;